/**
 * Statsig feature flag gate names.
 * Create the corresponding gate in the Statsig console to enable features.
 */
export const ATOMIC_ICB_ENABLED_GATE = "atomic-icb-enabled";

/** Step run list: Temporal workflow reset (replay) from a step. */
export const ATOMIC_STEP_RUN_REPLAY_ENABLED_GATE =
  "atomic-step-run-replay-enabled";

/** Process run retry: opt in to active deployment step config on manual retry. */
export const ATOMIC_RETRY_ACTIVE_DEFINITION_ENABLED_GATE =
  "atomic-retry-active-definition-enabled";
